import { TaskStatus } from '../types/interfaces';

export const TaskStatusTemplate: TaskStatus = {
  id: '',
  statusName: '',
  taskCloseCodes: [],
  availableForImport: false
};
